<div style="padding: 20px; min-width: 450px;">
  <!-- Field Information -->
  <div style="margin-bottom: 20px;">
    <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">
      Field Changed
    </label>
    <div style="padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
      {{ getFormattedFieldName() || 'N/A' }}
    </div>
  </div>

  <!-- Old Value -->
  <div style="margin-bottom: 20px;">
    <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">
      Previous Value
    </label>
    <div style="padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
      {{ formattedOldValue || (oldValue ?? 'N/A') }}
    </div>
  </div>

  <!-- New Value -->
  <div style="margin-bottom: 20px;">
    <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">
      New Value
    </label>
    <div style="padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
      {{ formattedNewValue || (newValue ?? 'N/A') }}
    </div>
  </div>

  <!-- Comment Text Area -->
  <div style="margin-bottom: 20px;">
    <label style="display: block; margin-bottom: 8px; font-weight: bold; color: #333;">
      Comment <span style="color: red;">*</span>
    </label>
    <dx-text-area data-testid="field-change-comment-text-area"
      [(value)]="comment"
      (onValueChanged)="onCommentChanged($event)"
      valueChangeEvent="keyup"
      placeholder="Enter reason for change"
      height="100"
      style="width: 100%;"
      showClearButton="true">
    </dx-text-area>
  </div>

  <!-- Action Buttons -->
  <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px;">
    <dx-button data-testid="field-change-comment-submit-button"
      text="Submit"
      type="default"
      [disabled]="!isFormValid()"
      (onClick)="onSubmit()">
    </dx-button>
    <dx-button data-testid="field-change-comment-cancel-button"
      text="Cancel"
      type="normal"
      (onClick)="onDismiss()">
    </dx-button>
  </div>
</div>
